// EmptyState — what to show when a list/dashboard has no data yet.
// Used by Inbox (no notices), Today (no arrivals), Audit log (no
// matching entries), etc. Communicates that the system worked AND
// suggests the next action.

import type { ReactNode } from "react";

import { tokens } from "../tokens/tokens";

export interface EmptyStateProps {
  /** Short heading. e.g. "अहिले कुनै सूचना छैन" / "No notices yet" */
  title: string;
  /** Sub-line explaining how to get there. */
  description?: string;
  /** Action (button, link) the user can take. */
  action?: ReactNode;
  /** Optional icon / illustration above the title. */
  icon?: ReactNode;
}

export function EmptyState({ title, description, action, icon }: EmptyStateProps) {
  return (
    <div
      role="status"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: tokens.space[2],
        padding: tokens.space[8],
        textAlign: "center",
        color: tokens.color.semantic.textMuted,
      }}
    >
      {icon && <div aria-hidden="true">{icon}</div>}
      <p
        style={{
          fontSize: tokens.type.size.lg,
          fontWeight: tokens.type.weight.semibold,
          color: tokens.color.semantic.text,
        }}
      >
        {title}
      </p>
      {description && (
        <p style={{ fontSize: tokens.type.size.sm, maxWidth: "40ch" }}>
          {description}
        </p>
      )}
      {action && <div style={{ marginTop: tokens.space[2] }}>{action}</div>}
    </div>
  );
}
